<template>
  <div>
    <b-columns>
      <b-column class="is-narrow">
        <header>
          <h3 class="category-heading is-size-4">{{ data.name }}</h3>
        </header>
      </b-column>
      <b-column v-if="data.guide_pdf">
        <pdf-link :url="data.guide_pdf" />
      </b-column>
    </b-columns>

    <key-value-table
      :items="tableItems"
    />

    <section>
      <header class="has-text-weight-semibold">Guide</header>
      <p>
        {{ data.guides }}
      </p>
    </section>

  </div>
</template>

<script>
import KeyValueTable from '@/components/structures/KeyValueTable'

export default {
  name: 'Detector',
  components: {
    KeyValueTable
  },
  props: {
    data: {
      type: Object,
      default: () => ({ name: '' })
    }
  },
  computed: {
    tableItems () {
      return [
        { label: 'Manufacturer', value: this.data.manufacturer },
        { label: 'Technology', value: `${this.data.detector_technology.name} - ${this.data.detector_technology.description}` },
        { label: 'Operational time', value: this.data.operational_time },
        { label: 'Size', value: this.data.size },
        { label: 'Weight', value: this.data.weight },
      ]
    }
  }
}
</script>

<style>

</style>
